import React, { useEffect, useState } from 'react';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  getExchangeEvents,
  fetchEventsByCompetition,
  setExchEvent,
  setCompetition,
  fetchEventsBySport,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import './ExchEventsTable.scss';
import { IonCol, IonRow } from '@ionic/react';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { formatDate } from '../../util/stringUtil';
import moment from 'moment';
import ExchMobOddView from '../ExchOddButton/ExchMobOddView';
import { EventDTO } from '../../models/common/EventDTO';
import sheduleImg from '../../assets/images/sportsbook/icons/shedule.svg';
import { unsubscribeAllWsforEvents } from '../../webSocket/webSocket';
import ExchangeSportsIconList from '../../components/ExchSportsListNav/ExchangeSportsIconList';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import tvIcon from '../../assets/images/sportsbook/icons/tvIcon.svg';
import tvIconMob from '../../assets/images/sportsbook/icons/tvIcon.svg';

type StoreProps = {
  events: EventDTO[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  fetchEventsByCompetition: (
    sportId: string,
    competitionId: string,
    events: EventDTO[]
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  setCompetition: (competition: SelectedObj) => void;
  fetchEventsBySport: (sportId: string, events: EventDTO[]) => void;
  fetchingEvents: boolean;
  loggedIn: boolean;
};

const EventsTable: React.FC<StoreProps> = (props) => {
  const {
    events,
    selectedEventType,
    selectedCompetition,
    fetchEventsByCompetition,
    setExchEvent,
    setCompetition,
    fetchEventsBySport,
    fetchingEvents,
    loggedIn,
  } = props;

  const pathParams = useParams();
  const teamTypes = ['home', 'draw', 'away'];
  const [wsChannels, setWsChannels] = useState<string[]>([]);

  const history = useHistory();

  const tableFields = [
    {
      key: 'Match',
      Label: 'MATCH',
      className: 'schedule-cell schedule-cell-header',
      align: 'left',
    },
    { key: 'teams', Label: 'TEAMS', className: 'teams-cell', align: 'left' },
    {
      key: 'icons',
      Label: '',
      className: 'schedule-cell web-view',
      align: 'left',
    },
    {
      key: 'homeTeamOdds',
      Label: '1',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'drawOdds',
      Label: 'X',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'awayTeamOdds',
      Label: '2',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
  ];
  const getOdds = (eventData: EventDTO, teamType: string) => {
    const team =
      teamType === 'home'
        ? eventData.homeTeam
        : teamType === 'away'
        ? eventData.awayTeam
        : teamType;
    for (let runner of eventData.matchOdds.runners) {
      if (
        runner.runnerName.toLowerCase() === team.toLowerCase() ||
        runner.runnerName.toLowerCase().includes(team.toLowerCase())
      ) {
        return [
          {
            type: 'back-odd',
            price: runner?.backPrices[0]?.price,
            size: runner?.backPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner?.runnerName,
          },
          {
            type: 'lay-odd',
            price: runner.layPrices[0]?.price,
            size: runner.layPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner?.runnerName,
          },
        ];
      }
    }
    return null;
  };

  useEffect(() => {
    if (!pathParams['competition']) {
      setCompetition({ id: '', name: '', slug: '' });
    }
  }, [pathParams]);

  const updateEvents = () => {
    if (!pathParams['competition']) {
      fetchEventsBySport(selectedEventType.id, events);
    } else {
      fetchEventsByCompetition(
        selectedEventType.id,
        selectedCompetition.id,
        events
      );
    }
  };

  useEffect(() => {
    if (!pathParams['competition']) {
      fetchEventsBySport(selectedEventType.id, events);
    }
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition'] && !events) {
      fetchEventsByCompetition(
        selectedEventType.id,
        selectedCompetition.id,
        events
      );
    }
  }, [selectedCompetition]);

  useEffect(() => {
    updateEvents();
  }, [loggedIn]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvents();
    }, 30 * 1000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [selectedEventType]);

  // Unsubscribe Web socket messages
  useEffect(() => {
    unsubscribeAllWsforEvents();
    setWsChannels([]);
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition']) {
      unsubscribeAllWsforEvents();
      setWsChannels([]);
    }
  }, [selectedCompetition, pathParams]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     if (events) {
  //       for (let event of events) {
  //         if (event.matchOdds.inplay) {
  //           subscribeWsForEventOdds(
  //             event.sportId,
  //             event.competitionId,
  //             event.eventId,
  //             event.matchOdds?.marketId,
  //             event.providerName
  //           );
  //         }
  //       }
  //     }
  //   }
  // }, [isConnected(), events, selectedEventType, loggedIn]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  const handleEventChange = (event: EventDTO) => {
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: getCompetitionSlug(event.competitionName),
    });
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
  };

  const redirectToAllMarkets = (sEvent: EventDTO) => {
    history.push(
      `/exchange_sports/${selectedEventType.slug}/${getCompetitionSlug(
        sEvent.competitionName
      )}/${sEvent.eventSlug}/${btoa(
        `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}`
      )}`
    );
  };
  return (
    <div className="events-table-ctn">
      <div className="events-section">
        <div className="card">
          <div className="carw">
            <div className="arrow arrow-right">
              <div className="img-ctn">
                <img
                  className={'sport-icon'}
                  alt={selectedEventType?.name}
                  src={
                    SPORTS_ICONS[selectedEventType?.name]
                      ? SPORTS_ICONS[selectedEventType?.name]
                      : SPORTS_ICONS['Other']
                  }
                />
              </div>
              {selectedEventType?.name}
            </div>
          </div>
          <div className="nav-list-event-table">
            <ExchangeSportsIconList />
          </div>

          {events ? (
            events.length > 0 ? (
              <div className="events-table-content table-ctn mt-6">
                <TableContainer component={Paper} className="border-radius">
                  <Table className="events-table inplay-table">
                    <TableHead>
                      <TableRow>
                        {tableFields.map((tF, index) => (
                          <TableCell
                            key={tF.key + index}
                            align={tF.align === 'left' ? 'left' : 'center'}
                            colSpan={tF.colSpan ? tF.colSpan : 1}
                            className={tF.className}
                          >
                            {tF.Label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {events.map((sEvent, idx) => (
                        <TableRow
                          key={sEvent.eventSlug + sEvent.competitionName + idx}
                          onClick={(e) => {
                            redirectToAllMarkets(sEvent);
                          }}
                        >
                          <TableCell className="schedule-cell1 tab-view">
                            <div className="date">
                              {formatDate(sEvent.openDate)}
                            </div>
                          </TableCell>
                          <TableCell className="teams-cell">
                            <div
                              className="all-markets-nav-link"
                              onClick={() => handleEventChange(sEvent)}
                            >
                              {sEvent.homeTeam !== '' &&
                              sEvent.awayTeam !== '' ? (
                                <>
                                  <div className="odds-web-view">
                                    <IonRow className="teams-col">
                                      <div className="teams">
                                        <div className="team-name">
                                          {sEvent.homeTeam}
                                        </div>
                                        <div className="team-name">
                                          {sEvent.awayTeam}
                                        </div>
                                      </div>
                                    </IonRow>
                                  </div>

                                  <div className="mob-view event-info">
                                    <div className="event-name">
                                      {' '}
                                      <span className="event">
                                        {sEvent.eventName}
                                      </span>
                                      <span className="date">
                                        {' '}
                                        {moment(sEvent.openDate).format(
                                          'DD/MM/YY; hh:mm A'
                                        )}
                                      </span>
                                    </div>
                                    {sEvent ? (
                                      <div className="icon-mob-ctn">
                                        {sEvent?.status === 'IN_PLAY' ? (
                                          <img
                                            className="icon-market"
                                            src={tvIconMob}
                                            height={16}
                                            width={16}
                                          />
                                        ) : null}
                                        <div className="icon-ctn">
                                          {' '}
                                          {sEvent?.enablePremium ? (
                                            <div className="p-circle">P</div>
                                          ) : null}
                                          {sEvent?.enableMatchOdds ? (
                                            <div className="mo-circle">MO</div>
                                          ) : null}
                                          {sEvent?.enableBookmaker ? (
                                            <div className="bm-circle">BM</div>
                                          ) : null}
                                          {sEvent?.enableFancy ? (
                                            <div className="f-circle">F</div>
                                          ) : null}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="teams web-view">
                                    <div className="team-name">
                                      {sEvent.eventName}
                                    </div>
                                  </div>

                                  <IonRow className="odds-mob-view  mob-view">
                                    <IonCol
                                      className="event-info mob-view"
                                      sizeXs="12"
                                      sizeSm="12"
                                    >
                                      {' '}
                                      <div className="event-name">
                                        {' '}
                                        <span className="event">
                                          {sEvent.eventName}
                                        </span>
                                        <span className="date">
                                          {' '}
                                          {moment(sEvent.openDate).format(
                                            'DD/MM/YY; hh:mm A'
                                          )}
                                        </span>
                                      </div>
                                    </IonCol>
                                  </IonRow>
                                </>
                              )}
                              <div className="lap-view odds-row">
                                {teamTypes.map((teamType, index) => (
                                  <React.Fragment
                                    key={sEvent?.eventName + teamType + index}
                                  >
                                    <div className="odds-block">
                                      {sEvent.matchOdds ? (
                                        getOdds(sEvent, teamType) ? (
                                          <>
                                            {getOdds(sEvent, teamType).map(
                                              (odd, ind) => (
                                                <ExchMobOddView
                                                  key={
                                                    odd.type + odd?.price + index
                                                  }
                                                  mainValue={odd?.price}
                                                  oddType={
                                                    odd.type === 'back-odd'
                                                      ? 'back-odd'
                                                      : 'lay-odd'
                                                  }
                                                  disable={sEvent.matchOdds.status
                                                    .toLowerCase()
                                                    .includes('suspended')}
                                                />
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="back-odd"
                                              disable={false}
                                            />
                                            <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="lay-odd"
                                              disable={false}
                                            />
                                          </>
                                        )
                                      ) : (
                                        <>
                                          <ExchMobOddView
                                            mainValue={'-'}
                                            oddType="back-odd"
                                            disable={false}
                                          />
                                          <ExchMobOddView
                                            mainValue={'-'}
                                            oddType="lay-odd"
                                            disable={false}
                                          />
                                        </>
                                      )}
                                    </div>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="web-view">
                            {sEvent ? (
                              <div className="icon-cell">
                                {sEvent?.status === 'IN_PLAY' ? (
                                  <img
                                    className="icon-market"
                                    src={tvIcon}
                                    height={16}
                                    width={16}
                                  />
                                ) : null}
                                <div className="icon-ctn">
                                  {' '}
                                  {sEvent?.enablePremium ? (
                                    <div className="p-circle">P</div>
                                  ) : null}
                                  {sEvent?.enableMatchOdds ? (
                                    <div className="mo-circle">MO</div>
                                  ) : null}
                                  {sEvent?.enableBookmaker ? (
                                    <div className="bm-circle">BM</div>
                                  ) : null}
                                  {sEvent?.enableFancy ? (
                                    <div className="f-circle">F</div>
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                          </TableCell>
                          {teamTypes.map((teamType, index) => (
                            <TableCell
                              className="odds-cell tab-view"
                              align="center"
                              colSpan={2}
                              key={sEvent.openDate + teamType + index}
                            >
                              {sEvent.matchOdds ? (
                                getOdds(sEvent, teamType) ? (
                                  <div className="odds-block">
                                    {getOdds(sEvent, teamType).map(
                                      (odd, idx) => (
                                        <ExchOddBtn
                                          key={odd.type + odd?.price + idx}
                                          mainValue={odd?.price}
                                          subValue={odd?.size}
                                          oddType={
                                            odd.type === 'back-odd'
                                              ? 'back-odd'
                                              : 'lay-odd'
                                          }
                                          valueType="matchOdds"
                                          showSubValueinKformat={true}
                                          disable={sEvent.matchOdds.status
                                            .toLowerCase()
                                            .includes('suspended')}
                                          onClick={() => null}
                                        />
                                      )
                                    )}
                                  </div>
                                ) : (
                                  <EmptyOddsBlock
                                    providerName={sEvent.providerName}
                                  />
                                )
                              ) : (
                                <EmptyOddsBlock
                                  providerName={sEvent.providerName}
                                />
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : !fetchingEvents ? (
              <div className="events-table-msg-text">No Events to display</div>
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

function EmptyOddsBlock(props: { providerName: string }) {
  const { providerName } = props;

  return (
    <React.Fragment>
      <div className="odds-block">
        <ExchOddBtn
          mainValue={'-'}
          subValue={null}
          disable={false}
          oddType="back-odd"
        />
        <ExchOddBtn
          mainValue={'-'}
          subValue={null}
          disable={false}
          oddType="lay-odd"
        />
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  return {
    events: getExchangeEvents(
      state.exchangeSports.events,
      eventType.id,
      competition.id
    ),
    selectedEventType: eventType,
    selectedCompetition: competition,
    fetchingEvents: state.exchangeSports.fetchingEvents,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventsByCompetition: (
      sportId: string,
      competitionId: string,
      events: EventDTO[]
    ) => dispatch(fetchEventsByCompetition(sportId, competitionId, events)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    fetchEventsBySport: (sportId: string, events: EventDTO[]) =>
      dispatch(fetchEventsBySport(sportId, events)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsTable);
